import { render } from "./AdminNavGroup.vue?vue&type=template&id=434d8c55"
import script from "./AdminNavGroup.vue?vue&type=script&lang=js"
export * from "./AdminNavGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__